<nz-skeleton [nzActive]="true"
      [nzLoading]="true"
      [nzParagraph]="false"
      [nzAvatar]="{size: 'large', shape: 'square'}">
</nz-skeleton>